import funcoes from "../../../../util/funcoes"
import { BANCOS, STATUS_CONTRATO_ALUGUEL, STATUS_RECIBO_REPASSE, FORMA_PAGAMENTO, TIPO_BOLETO_REMESSA } from "../../../../util/constantes";
import { mapActions, mapState } from "vuex";

import AppSelecionarContaBancariaDialog from '../../../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import AppSelecionarAluguelDialog from '../../../../shared/dialogs/SelecionarAluguelDialog.vue';

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSortAlphaDown, faSortNumericDown, faSortNumericUp, faStopCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faSortAlphaDown, faSortNumericDown, faSortNumericUp, faStopCircle)

export default {
  components: {
    AppSelecionarContaBancariaDialog,
    AppSelecionarAluguelDialog,
  },
  data() {
    //A PESQUISA MANDA COMO REMESSA, ENTÂO O NOME DO OBJETO NÃO FOI ALTERADO.
    return {
      remessa: {
        dataInicio: funcoes.primeiroDiaMes(),
        dataFim: funcoes.ultimoDiaMes(),
        tipoData: 'DATA_VENCIMENTO',
        tipoBoletoRemessa: 'TODOS'
      },

      validacao: {
        dataInicio: [{ required: true, len: 10 }],
        dataFim: [{ required: true, len: 10 }]
      },

      contaBancaria: { nome: undefined },
      aluguel: { id: 0, idNaImobiliaria: '' },
      cliente: { id: 0, nome: '' },

      visibilidadeSelecionarContaBancariaDialog: false,
      visibilidadeSelecionarAluguelDialog: false,

      alugueis: undefined,
      clientes: undefined,

      loadingAluguel: false,
      loadingCliente: false,

      filtragemAtual: 'SEM_ORDENACAO',

      stateFilterButton: {
        labelFilterButton: 'Sem Ordenação',
        iconFilterButton: 'stop-circle',
        color: '#DF1B1B'
      },

      currentPageTitulos: 1,
      maxItens: 100,
    }
  },

  computed: {
    ...mapState('registrosApiStore', {
      titulos(state) { return state.titulos },
    }),
    formasPagamento() {
      return FORMA_PAGAMENTO
    },
    bancos() {
      return BANCOS
    },
    tiposBoletosRemessa() {
      return TIPO_BOLETO_REMESSA;
    },
    titulosFiltrados(state) { return state.titulos.slice(this.paginaAtualTitulosParaIndice * this.maxItens, this.currentPageTitulos * this.maxItens).filter( titulo => !titulo.dataRegistro ) },
    quantidadeTotalTitulos(state) { return state.titulos.filter( titulo => !titulo.dataRegistro).length },
    quantidadeTitulosSelecionados(state) { return state.titulos.filter(item => { return item.selecionado && !item.dataRegistro }).length },

    paginaAtualTitulosParaIndice() {
      return this.currentPageTitulos - 1;
    },
    exibirLabelSelecionados() {
      return this.quantidadeTitulosSelecionados > 0
    },
    labelTitulosSelecionados() {
      switch (this.quantidadeTitulosSelecionados) {
        case 1:
          return `${this.quantidadeTitulosSelecionados} Boleto selecionado`
        case 0:
          return '';
        default:
          return ` ${this.quantidadeTitulosSelecionados} Boletos selecionados`
      }
    },
    labelQuantidadeTitulos() {
      switch (this.quantidadeTotalTitulos) {
        case 1:
          return `${this.quantidadeTotalTitulos} Boleto encontrado`
        case 0:
          return '';
        default:
          return `Exibindo ${this.paginaAtualTitulosParaIndice * this.maxItens + 1} a ${this.titulosFiltrados.length + this.paginaAtualTitulosParaIndice * this.maxItens} de ${this.quantidadeTotalTitulos} Boletos`
      }
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('remessasStore', [
      'listarAlugueis',
      'listarClientes'
    ]),
    ...mapActions('registrosApiStore', [
      'listarTitulos',
      'selecionarTodos',
      'deselecionarTodos',
      'registrarTitulos'
    ]),

    listarTitulosHandler() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.showLoading()

          if (this.contaBancaria.id) { this.remessa.idContaBancaria = this.contaBancaria.id }
          if (this.aluguel.id > 0) { this.remessa.idAluguel = this.aluguel.id }
          if (this.cliente.id > 0) { this.remessa.idCliente = this.cliente.id }

          this.listarTitulos(this.remessa)
            .then(() => {
              this.hideLoading()
              this.limparCampos();
            })
            .catch(() => {
              this.hideLoading()
              this.limparCampos();
              this.$message.error("Não foi possível conectar-se ao servidor");
            });
        }
      });
    },
    
    registrarBoletosHandler() {
      this.$confirm('Ao confirmar, os títulos selecionados serão registrados no respectivo banco selecionado, que pode gerar cobranças conforme normas do mesmo. Deseja prosseguir?',{
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.showLoading();
        const payload = {
          contaBancaria: this.contaBancaria,
          recibos: this.titulosFiltrados.filter(titulo => titulo.selecionado && titulo.mesSerie).map(titulo => { return { ...titulo, selecionado: undefined } }),
          boletosAvulsos: this.titulosFiltrados.filter(titulo => titulo.selecionado && !titulo.mesSerie).map(titulo => { return { ...titulo, selecionado: undefined } })
        }

        this.registrarTitulos(payload)
        .then(response => {
          this.hideLoading();
          if(response.status === 'SUCESSO') {
            this.listarTitulosHandler();
            this.limparCampos();
            this.$message.success(response.mensagem);
          }
        }).finally(() => {
          this.hideLoading();
        })
      })
    },

    filtrarAlugueisSelect(queryString) {
      let payload = {
        idNaImobiliaria: queryString
      }

      this.loadingAluguel = true;
      this.listarAlugueis(payload)
        .then((response) => {
          this.alugueis = response.lista;
          this.loadingAluguel = false;
        }).catch(() => {
          this.loadingAluguel = false;
        })
    },

    filtrarClientesSelect(queryString) {
      let payload = {
        nome: queryString
      }

      this.loadingCliente = true;
      this.listarClientes(payload)
        .then((response) => {
          this.clientes = response.lista;
          this.loadingCliente = false;
        }).catch(() => {
          this.loadingCliente = false;
        })
    },

    exibirSelecionarContaBancariaDialog() {
      this.visibilidadeSelecionarContaBancariaDialog = true
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) {
      this.contaBancaria = contaBancaria
      this.visibilidadeSelecionarContaBancariaDialog = false;
    },
    exibirSelecionarAluguelDialog() {
      this.visibilidadeSelecionarAluguelDialog = true
    },
    fecharSelecionarAluguelDialog(aluguel) {
      this.aluguel = aluguel ? aluguel : { id: 0, idNaImobiliaria: '' }
      this.visibilidadeSelecionarAluguelDialog = false;
    },

    limparAluguel() {
      this.aluguel = { id: 0, idNaImobiliaria: '' }
    },
    limparCampos() {
      this.remessa = {
        ...this.remessa,
      }
    },

    filtrarLista() {
      switch (this.filtragemAtual) {
        case 'SEM_ORDENACAO':
          this.filtragemAtual = 'ALFABETICA';
          this.atualizarEstadoBotaoFiltro();

          this.titulos.sort((itemA, itemB) => {
            if (itemA.cliente.nome < itemB.cliente.nome) {
              return -1;
            } else {
              true;
            }
          });

          break;
        case 'ALFABETICA':
          this.filtragemAtual = 'NUMERO_RECIBO';
          this.atualizarEstadoBotaoFiltro();

          this.titulos.sort((itemA, itemB) => {
            if (itemA.numero < itemB.numero) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case 'NUMERO_RECIBO':
          this.filtragemAtual = 'MES_SERIE';
          this.atualizarEstadoBotaoFiltro();

          this.titulos.sort((itemA, itemB) => {
            if (itemA.mesSerie < itemB.mesSerie) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case 'MES_SERIE':
          this.filtragemAtual = 'SEM_ORDENACAO';
          this.atualizarEstadoBotaoFiltro();

          this.titulos.sort((itemA, itemB) => {
            return funcoes.stringParaData(itemA.dataVencimento).getTime() - funcoes.stringParaData(itemB.dataVencimento).getTime()
          });
          break;
        default:
          break;
      }
    },

    atualizarEstadoBotaoFiltro() {
      switch (this.filtragemAtual) {
        case 'SEM_ORDENACAO':
          this.stateFilterButton = {
            labelFilterButton: 'Sem Ordenação',
            iconFilterButton: 'stop-circle',
            color: '#DF1B1B'
          }
          break;
        case 'ALFABETICA':
          this.stateFilterButton = {
            labelFilterButton: 'Ordem Alfabética',
            iconFilterButton: 'sort-alpha-down',
            color: '#4B6EF6'
          }
          break;
        case 'NUMERO_RECIBO':
          this.stateFilterButton = {
            labelFilterButton: 'Número recibo',
            iconFilterButton: 'sort-numeric-down',
            color: '#4B6EF6'
          }
          break;
        case 'MES_SERIE':
          this.stateFilterButton = {
            labelFilterButton: 'Mes Série',
            iconFilterButton: 'sort-numeric-down',
            color: '#4B6EF6'
          }
          break;
        default:
          break;
      }
    },

    formatarIconStatus(item) {
      switch (item) {
        case 'EM_ABERTO':
          return '#4B6EF6';
        case 'PAGO':
          return '#2DB748';
      }
    },

    getLabelStatus(item) {
      return funcoes.getLabel(STATUS_RECIBO_REPASSE, item.status)
    },
    getLabelStatusAluguel(item) {
      return funcoes.getLabel(STATUS_CONTRATO_ALUGUEL, item.aluguel.status)
    },
    formatarPeriodo(item) {
      return item.inicioPeriodo ? item.inicioPeriodo + ' - ' + item.fimPeriodo : ''
    },
    formatarValor(item) {
      return funcoes.formatarValor(item.valor)
    },
    formatarValorPago(item) {
      return funcoes.formatarValor(item.valorPago)
    },
  }
}